import gql from 'graphql-tag';

/**
 * Prodotti "potenziali" di un Company360: i Good del suo company/brand/retailer/foodservice.
 * Per ciascuno scarichiamo anche l'eventuale Good360 collegato, così da sapere se è già stato
 * importato. Paginato (page size 50) tramite endCursor.
 */
export const ImportGoods360Query = gql`
	query ImportGoods360Query($company360Id: ID!, $cursor: String) {
		goods(
			filter: { GoodForNewCompany360: { id: $company360Id } }
			first: 50
			after: $cursor
		) {
			edges {
				node {
					id
					localId
					name
					Good360 {
						id
					}
				}
			}
			total
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;